exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dash-text[data-v-3c711bba]{font-size: 16px;}\n.dash-text span[data-v-3c711bba]{font-size: 17px;}\n.setting-btn[data-v-3c711bba]{font-size: 17px;}\n.dash-icon[data-v-3c711bba] {font-size: 21px;}\n.cmn-dash-tab.selected[data-v-3c711bba]{border: 1px solid #26980f;}\n", ""]);

// exports
